import { render, staticRenderFns } from "./PatientNew.vue?vue&type=template&id=01e7cfd1"
import script from "./PatientNew.vue?vue&type=script&lang=js"
export * from "./PatientNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports